import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { Toaster } from './components/ui/Toast'

// Context Providers
import { AuthProvider } from './contexts/AuthContext.jsx'

// Layout Components
import AppLayout from './components/organisms/AppLayout'
import ProtectedRoute from './components/auth/ProtectedRoute'

// Pages
import HomePage from './pages/HomePage'
import AboutPage from './pages/AboutPage'
import LoginPage from './pages/LoginPage'
import TermsPage from './pages/TermsPage'
import PrivacyPage from './pages/PrivacyPage'
import LeaderboardPage from './pages/LeaderboardPage'
import DashboardPage from './pages/DashboardPage'
import ProjectsPage from './pages/ProjectsPage'
import ProjectDetailPage from './pages/ProjectDetailPage'
import ProjectView from './pages/ProjectView'
import CreateProjectPage from './pages/CreateProjectPage'
import ProfilePage from './pages/ProfilePage'

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="min-h-screen bg-neutral-100">
          <Routes>
            {/* Public routes without common layout */}
            <Route path="/" element={<HomePage />} />
            <Route path="/login" element={<LoginPage />} />

            {/* Public routes WITH AppLayout */}
            <Route element={<AppLayout />}>
              <Route path="/about" element={<AboutPage />} />
              <Route path="/terms" element={<TermsPage />} />
              <Route path="/privacy" element={<PrivacyPage />} />
              <Route path="/leaderboards" element={<LeaderboardPage />} />
              <Route path="/projects" element={<ProjectsPage />} />
              <Route path="/project/:slug" element={<ProjectView />} />
              <Route path="/projects/:slug" element={<ProjectDetailPage />} />
            </Route>

            {/* Protected routes with AppLayout */}
            <Route element={<ProtectedRoute><AppLayout /></ProtectedRoute>}>
              <Route path="/dashboard" element={<DashboardPage />} />
              <Route path="/profile" element={<ProfilePage />} />
            </Route>

            {/* Project creation route - requires create_project capability */}
            <Route element={<ProtectedRoute requireCapability="create_project"><AppLayout /></ProtectedRoute>}>
              <Route path="/create" element={<CreateProjectPage />} />
            </Route>
          </Routes>

          {/* Toast notifications */}
          <Toaster />
        </div>
      </Router>
    </AuthProvider>
  )
}

export default App
